import React, { Component } from 'react'
import {
  sortableContainer,
  sortableElement,
  arrayMove
} from 'react-sortable-hoc'
import styles from './style.module.less'

const ListWrap = sortableContainer(({ children }) => (
  <div className={styles.container}>{children}</div>
))
const ItemWrap = sortableElement(({ children }) => children)

export default class extends Component {
  onSortEndHandler = ({ oldIndex, newIndex }) => {
    const { data, onSortEnd } = this.props
    const newData = arrayMove(data, oldIndex, newIndex)
    onSortEnd(newData)
  }

  render() {
    const { data = [[]], render, children } = this.props

    return (
      <ListWrap
        axis="xy"
        onSortEnd={this.onSortEndHandler}
        hideSortableGhost={false}
      >
        {data.map((item, index) => (
          <ItemWrap key={item.id || item.uid || index} index={index}>
            {render(item, index)}
          </ItemWrap>
        ))}
        {children}
      </ListWrap>
    )
  }
}
